var React = require('react');

function TimeLine (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.0003 18.8334C5.39783 18.8334 1.66699 15.1026 1.66699 10.5001C1.66699 5.89758 5.39783 2.16675 10.0003 2.16675C14.6028 2.16675 18.3337 5.89758 18.3337 10.5001C18.3337 15.1026 14.6028 18.8334 10.0003 18.8334ZM10.0003 17.1667C11.7684 17.1667 13.4641 16.4644 14.7144 15.2141C15.9646 13.9639 16.667 12.2682 16.667 10.5001C16.667 8.73197 15.9646 7.03628 14.7144 5.78604C13.4641 4.53579 11.7684 3.83341 10.0003 3.83341C8.23221 3.83341 6.53652 4.53579 5.28628 5.78604C4.03604 7.03628 3.33366 8.73197 3.33366 10.5001C3.33366 12.2682 4.03604 13.9639 5.28628 15.2141C6.53652 16.4644 8.23221 17.1667 10.0003 17.1667ZM10.8337 10.5001H14.167V12.1667H9.16699V6.33341H10.8337V10.5001Z","fill":"currentColor"}));
}

TimeLine.defaultProps = {"viewBox":"1 2 18 18","fill":"none"};

module.exports = TimeLine;

TimeLine.default = TimeLine;
